<script setup lang="ts">
  import { FlowTravelersWidget } from '@/widgets/Flow'
  import { useApiRequestsAbort } from '@/shared/composables'
  import { TravelDirection } from '@/shared/types/common.types'

  useApiRequestsAbort()
</script>

<template>
  <FlowTravelersWidget :type-of-travel="TravelDirection.INBOUND" />
</template>
